import {Directive, HostBinding, Input} from "@angular/core";

@Directive()
export abstract class FUIAbstractLoader {
    @HostBinding("style.height.px") @Input() public height: number;
    @HostBinding("style.width.px") @Input() public width: number;

    constructor() {

    }
}
